import { Link } from "react-router-dom";

const categoryLinks = [
  { label: "最新电影", to: "/category/movie" },
  { label: "热播电视剧", to: "/category/tv" },
  { label: "热门综艺", to: "/category/variety" },
  { label: "我的收藏", to: "/favorites" },
];

const helpLinks = [
  { label: "关于我们", to: "/about" },
  { label: "服务声明", to: "/about" },
  { label: "联系方式", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="mx-auto grid max-w-6xl grid-cols-1 gap-8 px-4 py-12 sm:grid-cols-2 md:px-8 lg:grid-cols-4">
        <div className="lg:col-span-1">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-base font-black text-primary-950">
              91
            </span>
            <span className="text-lg font-bold">在线观看视频</span>
          </div>
          <p className="mt-4 text-sm leading-relaxed text-background-100/70">
            面向中文用户的影视内容聚合与在线观看平台，汇集电影、电视剧、综艺等丰富资源，让好作品触手可及。
          </p>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-background-50">
            <Link to="/category/movie" className="hover:text-accent-400">影视分类</Link>
          </h4>
          <ul className="space-y-2.5">
            {categoryLinks.map((item) => (
              <li key={item.label}>
                <Link to={item.to} className="text-sm text-background-100/70 transition-colors hover:text-accent-400">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-background-50">
            <Link to="/about" className="hover:text-accent-400">帮助中心</Link>
          </h4>
          <ul className="space-y-2.5">
            {helpLinks.map((item) => (
              <li key={item.label}>
                <Link to={item.to} className="text-sm text-background-100/70 transition-colors hover:text-accent-400">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="mb-4 text-sm font-semibold text-background-50">联系我们</h4>
          <ul className="space-y-2.5 text-sm text-background-100/70">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-base text-accent-400"></i>
              support@91-video.example
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-time-line text-base text-accent-400"></i>
              服务时间 09:00 - 22:00
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-map-pin-line text-base text-accent-400"></i>
              线上服务平台
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-background-50/10">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-4 py-6 text-center sm:flex-row sm:justify-between sm:text-left md:px-8">
          <p className="text-xs text-background-100/60">
            © 2024 91在线观看视频. 本站内容均为演示示例，仅供学习与界面展示使用。
          </p>
          <p className="text-xs text-background-100/60">
            本站不存储、不提供任何真实影视资源，播放功能为界面演示。
          </p>
        </div>
      </div>
    </footer>
  );
}